import { Component, OnInit, OnDestroy } from '@angular/core';
import { LinkPathListApiInput, ErrCode } from '../../shared/models';
import { LinkFileListService } from '../services/link-file-list.service';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';
import { Subscription } from 'rxjs';
import { SyncCookieService } from '../../core/sync-cookie.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogReportLinkComponent } from '../dialog-report-link/dialog-report-link.component';
import { SyncDigestService } from '../../core/crypt/sync-digest.service';
import { LoggerService } from '../../core/logger.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'sync-applink-consume',
    templateUrl: './applink-consume.component.html',
})
export class ApplinkConsumeComponent implements OnInit, OnDestroy {
    public errcode: ErrCode;

    public openState: number;
    public isPro: number;
    public isBusiness = 1;

    //whitelabel attributes
    public isWhiteLabel: boolean;
    public linkTextColor: String;

    private sub: Subscription;

    constructor(
        private cookies: SyncCookieService,
        private digest: SyncDigestService,
        private log: LoggerService,
        private modalService: NgbModal,
        private store: Store<fromRoot.State>,
        private linkPathList: LinkFileListService,
        private route: ActivatedRoute
    ) {}

    ngOnInit() {
        this.openState = 0;
        this.cookies.setViewedLink();

        const linkPass = this.cookies.getLinkPassword(this.route.snapshot.params['cachekey']);

        // if (!this.getKey()) {
        //     this.errcode = new ErrCode(2015);
        //     this.openState = 3;
        // }
        this.sub = this.store
            .select(fromRoot.getLinkFileListState)
            .subscribe((data) => {
                //if user has a custom logo -> white label enabled
                if (data.whitelabel_loaded) {
                    if (data.image_cachekey) {
                        this.isWhiteLabel = true;
                        this.linkTextColor = data.link_text_color;
                    }
                }
                if (data.error) {
                    this.errcode = data.error.code == 8018 ? null : data.error;
                    if (data.error.code == 8018 || data.error.code == 8019) {
                        this.log.warn(
                            `App Link ${this.route.snapshot.params['cachekey']} requires a password`
                        );
                        this.cookies.deleteCookie(this.route.snapshot.params['cachekey']);
                        this.openState = 2; // this is a user requiring password lock
                    } else {
                        this.log.e(
                            `App Link ${this.route.snapshot.params['cachekey']} faced an error: `,
                            data.error
                        );
                        this.openState = 3;
                    }
                }
                if (data.loaded && data.sorted) {
                    if (data.passwordlock) {
                        this.cookies.setLinkPassword(
                            this.route.snapshot.params['cachekey'],
                            data.passwordlock
                        );
                    }
                    this.openState = 1;
                    this.isBusiness = data.is_business;
                }
                this.isPro = data.is_pro;
            });
        this.load(
            this.route.snapshot.queryParams['sync_id'],
            // this.getKey(),
            this.route.snapshot.params['cachekey'],
            linkPass
        );
    }

    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }

    // public load(syncId, key, publink_id, passlock?) {
    public load(syncId, publink_id, passlock?) {
        const input = new LinkPathListApiInput();
        input.sync_id = syncId;
        // input.key = key
        input.publink_id = publink_id;
        input.passwordlock = passlock;
        console.log('input in applink consume:', input);
        this.linkPathList.dispatchApp(input);
    }

    public onPassword(pass) {
        this.load(
            this.route.snapshot.queryParams['sync_id'],
            // this.getKey(),
            this.route.snapshot.params['cachekey'],
            this.digest.hash(pass)
        );
    }

    public onLinkKey(key) {
        console.log('KEY is ' + key);
        this.load(
            this.route.snapshot.queryParams['sync_id'],
            // key,
            this.route.snapshot.params['cachekey']
        );
    }

    public showReportDialog() {
        const ref = this.modalService.open(DialogReportLinkComponent, {
            backdropClass: 'in',
            windowClass: 'in',
            backdrop: 'static',
        });
        ref.componentInstance.linkID = this.route.snapshot.params['cachekey'];
    }

    // private getKey() {
    //     return this.$stateParams.key || this.$stateParams['#'];
    // }
}
